import { h, render, Component } from 'preact';
import { Router } from 'preact-router';
import { translate } from 'react-i18next';

import GameOverviewCard from '../GameOverviewCard';
//import GameInvites from '../GameInvites';

class Overview extends Component {

	
	// setEmailPrefs = (subPref) => {
	// 	console.log(subPref);
	// 	switch (subPref) {
	// 		case true:
	// 			this.setState({
	// 				prefFlag: 'true',
	// 				optOption: 'Unsubscribe from'
	// 			});
	// 			break;
	// 		case false:
	// 			this.setState({
	// 				prefFlag: 'false',
	// 				optOption: 'Subscribe to'
	// 			});
	// 			break;
	// 	}
	// }

	checkVerificationKey = () => {
		const key = this.getParameterByName('key');
		const type = this.getParameterByName('type');
		if (key) {
			let promise;
			if (type === 'verifyBackup') {
				promise = fetch('https://api.hirezstudios.com/acct/verifyBackupEmail', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: `{"webToken": "${this.context.userData.webToken}", "key": "${key}"}`
				})
			}
			else {
				promise = fetch('https://api.hirezstudios.com/acct/verify', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: `{
					"key": "${key}"
					}`
				})
			}
			promise.then((response) => response.json()).then((response) => {
				console.log('Verified');
			});
		}
	}

	getParameterByName = (name, url) => {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	sendVerification = () => {
		fetch('https://api.hirezstudios.com/acct/createVerification', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: `{
			"webToken": "${this.context.userData.webToken}"
			}`
		})
			.then((response) => response.json()).then((response) => {
				this.props.notification('success', 10000, `Verification email sent.`);
			});
	}
	subscribe = (event) => {
    fetch(`https://api.hirezstudios.com/acct/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: `{
          "webToken": "${this.context.userData.webToken}",
          "subscribe": "${event.target.checked}"
        }`
     })
		.then((response) => response.json()).then((response) => {
      if (response.statusCode === 200) {
        console.log('Success')  } 
      else {
        console.log('Error');
      }
    })
	}

	constructor() {
		super();
		this.state = {
			// prefFlag: null,
			// optOption: null
		};
	}

	componentDidUpdate() {
		if (this.context.accountInfo !== null && this.state.prefFlag === null) {
			this.setEmailPrefs(this.context.userData.accountInfo.contactInfo.subscriber);
		}
		this.checkVerificationKey();
	}

	render() {
		const { userData } = this.context;
		const { t } = this.props;

		return (
			<div className="view-overview">
				<h1>{t('Account Overview')}</h1>
				{userData.accountInfo &&
				<div className="account-information">
					<div className="title">
						<p>{t('Username:')}</p>
						<p>{t('E-mail:')}</p>
						<p>{t('Account Id:')}</p>
					</div>
					<div className="information">
						<p>{userData.accountInfo.name}</p>
						<div className="verify-email-container">
							<p className="email">{userData.accountInfo.contactInfo.email}</p>
							{(userData && userData.accountInfo.verified) ?
							<div className="edit-email">
								<a href="/edit-email">
									<p>{t('Change')}</p>
								</a>
							</div>
							:
							<div className="verify-email">
								<div>
									<p className="verify-link" onClick={() => this.sendVerification()}>{t('Please verify your email address.')}</p>
									<p>{t('After verification, you can change your email address and password.')}</p>
								</div>
							</div>
							}
						</div>
						<p>{userData.accountInfo.accountId}</p>
					</div>
					{/* <div className={`email-pref ${userData.accountInfo.contactInfo.subscriber}`}>
						<p>
							{this.state.optOption} Marketing Emails</p>
					</div> */}
				</div>
				}
				{userData.accountInfo &&
				<div>
					<div class="news-opt-in">
						<input type="checkbox" id="subscribeOptIn" name="subscribe" checked={userData.accountInfo.contactInfo.subscriber} onChange={this.subscribe} />
						<label for="subscribe"><p>{t('I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.')}</p></label>
					</div>
					<div className="games-container">
						{userData.accountInfo.games.map((data) =>
							(<GameOverviewCard
								name={data.playerName}
								game={data.game.toLowerCase().replace(/[^A-Z0-9]/ig, '-')}
								currencies={data.currency}
							 />)
						)}
					</div>
				</div>
				}
			</div>
		);
	}
}

export default translate(['common'], { withRef: true })(Overview);



// WEBPACK FOOTER //
// ./components/views/Overview.js